/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'close': {
    width: 21,
    height: 21,
    viewBox: '0 0 21 21',
    data: '<path pid="0" fill-rule="evenodd" d="M14.78 13.714a.753.753 0 01-1.066 1.066L10.5 11.565 7.286 14.78a.752.752 0 01-1.065 0 .753.753 0 010-1.066L9.435 10.5 6.22 7.286A.753.753 0 117.286 6.22L10.5 9.435l3.214-3.215a.753.753 0 011.065 1.066L11.565 10.5l3.214 3.214zM10.5 0C4.701 0 0 4.701 0 10.5S4.701 21 10.5 21 21 16.299 21 10.5 16.299 0 10.5 0z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/dist/icons/close.js